import React from 'react'

export default function TrustPilotIcon({ width = 37, height = 35, className }) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 37 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M36.3483 13.3149H22.4681L18.1807 0L13.8801 13.3149L0 13.3016L11.2409 21.5388L6.93984 34.8404L18.1807 26.6165L29.408 34.8404L25.1206 21.5388L36.3483 13.3149Z" fill="#00B67A"/>
    </svg>
  )
}
